<template>
  <div class="page-VolunteerSche">
    <h1 class="title">
      <i class="iconhebei iconbaoming2"></i>
      志愿者排班
    </h1>

    <div
      v-for="(item, index) in list"
      :key="item.id"
      class="page-VolunteerSche_list"
    >
      <div class="flex_box">
        <div class="page-VolunteerSche_username">姓名:{{ item.user_name }}</div>
        <div class="page-VolunteerSche_title">{{ item.title }}</div>
      </div>
      <div class="flex_box">
        <div class="page-VolunteerSche_startTime">{{ item.start }}</div>
        <div class="page-VolunteerSche_endTime">{{ item.end }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getVolunteerSchetUrl } from "@url";
export default {
  name: "VolunteerSche",
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    // 用户手机号
    userPhone() {
      return this.$store.state.userInfo.info.phone;
    },
  },
  methods: {
    async getData() {
      // 首次登陆无手机号 限制发送请求
      if (this.userPhone == "") {
        return this.$toast("请先绑定手机号！");
      }
      await axios
        .get(getVolunteerSchetUrl, {
          params: { phone: this.userPhone },
        })
        .then(
          ({
            data: {
              data: { data, code },
            },
          }) => {
            if (code === 200) {
              this.list = data.data;
            }
          }
        );
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  height: 46px;
  line-height: 46px;
  padding: 0 20px;
  color: #606060;
  font-size: 14px;
  font-weight: 500;
  .iconhebei {
    color: #5a9bf6;
  }
}
.page-VolunteerSche {
  .page-VolunteerSche_list {
    margin-bottom: 20px;
    background-color: #fff;
    padding: 10px 20px;

    .flex_box {
      display: flex;
      justify-content: space-between;
      height: 30px;
      line-height: 30px;
      .page-VolunteerSche_username {
        height: 30px;
        line-height: 30px;
        color: #1e52a0;
      }
      .page-VolunteerSche_title {
        color: #fd8d09;
      }
    }
  }
}
</style>